// extracted by mini-css-extract-plugin
export default {"home":"Home_home__Iy41P","appear":"Home_appear__AMkZc","message":"Home_message__3PDZ3","mandalorian-message":"Home_mandalorian-message__2ywLV"};